import { Announcement } from '@app/core/interfaces/c5/announcement';

export function calculateAnnouncementGroup(announcement: Announcement, mode: 'acd' | 'cc' = 'acd') {
  let group: string;

  if (announcement.acdQueueId == null && announcement.callCenterId != null) {
    group = 'announcements.types.CC';
  } else if (announcement.acdQueueId != null) {
    if (mode === 'acd') {
      group = `announcements.types.${announcement.type}`;
    } else if (mode === 'cc') {
      group = `announcements.types.CC_${announcement.type}`;
    }
  } else {
    group = `announcements.types.${announcement.type}`;
  }

  return group;
}
